export enum CmsWebsiteUserAgreementDocumentHdrObjectTypeConstant {
    PDF,
    DOCS,
    IMAGE,
    FILE
  }